(() => {
  if (window.__lbsMobileReserveLoaded) return;
  window.__lbsMobileReserveLoaded = true;
  const media = window.matchMedia('(max-width: 749px)');
  const root = document.querySelector('#MainContent');
  if (!root) return;
  let chosen = Boolean(new URLSearchParams(location.search).get('variant'));
  let updating = false;
  const bar = document.createElement('div');
  bar.className = 'lbs-mobile-reserve-bar';
  bar.innerHTML = '<button type="button" class="lbs-mobile-reserve-bar__button" aria-label="Choose a size before adding to cart">Select a Size</button>';
  document.body.appendChild(bar);
  const btn = bar.querySelector('button');
  const css = document.createElement('style');
  css.textContent = [
    '.lbs-mobile-reserve-bar{display:none}',
    '@media(max-width:749px){',
    '.lbs-mobile-reserve-bar{position:fixed;bottom:0;left:0;right:0;z-index:55;background:#fff;padding:9px max(12px,env(safe-area-inset-right)) calc(9px + env(safe-area-inset-bottom)) max(12px,env(safe-area-inset-left));box-shadow:0 -3px 16px rgba(0,0,0,.13);}',
    '.lbs-mobile-reserve-bar[data-visible="true"]{display:block}',
    'body:has(cart-drawer-component dialog[open]) .lbs-mobile-reserve-bar{display:none!important}',
    '.lbs-mobile-reserve-bar__button{width:100%;min-height:48px;padding:9px 13px;background:#193db7;color:white;border:0;border-radius:7px;font:600 13px/1.2 var(--font-body--family,Inter,sans-serif);letter-spacing:.035em;text-transform:uppercase;cursor:pointer}',
    '.lbs-mobile-reserve-bar__button:disabled{opacity:.65;cursor:wait}',
    'body:has(.lbs-mobile-reserve-bar[data-visible="true"]){padding-bottom:calc(70px + env(safe-area-inset-bottom))}',
    'body:has(.lbs-mobile-reserve-bar[data-visible="true"]) sticky-add-to-cart .sticky-add-to-cart__bar{display:none!important}',
    '}'
  ].join('');
  document.head.appendChild(css);
  const details = () => root.querySelector('.product-details');
  const picker = () => details()?.querySelector('.variant-picker');
  const reserve = () => details()?.querySelector('button[data-ladybird-preorder-button]:not([disabled])');
  const add = () => details()?.querySelector('product-form-component [ref="addToCartButton"]:not([disabled])');
  const visible = (el) => !!el && !!el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
  const primary = () => visible(reserve()) ? reserve() : visible(add()) ? add() : null;
  const scrollToSize = () => {
    const target = picker() || details()?.querySelector('.buy-buttons-block');
    target?.scrollIntoView({behavior:'smooth',block:'center'});
  };
  const selected = () => {
    const selectors = picker()?.querySelectorAll('fieldset.variant-option--buttons:not(.variant-option--swatches)');
    return selectors?.length ? Array.from(selectors).every(group => !!group.querySelector('input:checked')) : true;
  };
  const update = () => {
    if (!media.matches) {bar.dataset.visible='false';return;}
    const target = primary();
    const p = picker();
    const d = details();
    if (!d || !p) {bar.dataset.visible='false';return;}
    const rect = target?.getBoundingClientRect();
    const purchaseOnScreen = !!rect && rect.top < innerHeight - 65 && rect.bottom > 0;
    const footer = document.querySelector('footer');
    const footerOnScreen = footer && footer.getBoundingClientRect().top < innerHeight - 75;
    bar.dataset.visible=(!purchaseOnScreen && !footerOnScreen) ? 'true':'false';
    const hasSelection = chosen && selected();
    if (!hasSelection) {
      btn.disabled=false;
      btn.textContent='Select a Size';
      btn.setAttribute('aria-label','Choose a size before adding your Birdie to cart');
    } else if (visible(reserve())) {
      btn.disabled=false;
      btn.textContent='Add to Cart to Reserve';
      btn.setAttribute('aria-label','Add selected Birdie to cart. Checkout and payment are required to reserve.');
    } else if (visible(add())) {
      btn.disabled=false;
      btn.textContent='Add to Cart';
      btn.setAttribute('aria-label','Add selected Birdie size to cart');
    } else {
      btn.disabled=false;
      btn.textContent='Choose Another Size';
      btn.setAttribute('aria-label','Choose an available size');
    }
  };
  const purchase = () => {
    if (updating) return;
    if (!chosen || !selected()) { scrollToSize(); return; }
    const target = primary();
    if (!target) { scrollToSize(); return; }
    updating = true;
    target.click();
    setTimeout(() => { updating = false; update(); }, 1400);
  };
  btn.addEventListener('click', purchase);
  document.addEventListener('click', ev => {
    const jump=ev.target.closest('[data-lbs-jump-to-size]');
    if (jump) {ev.preventDefault();purchase();}
    const input=ev.target.closest('.variant-picker input[type="radio"], .variant-picker select');
    if(input && /size/i.test(input.name||input.closest('fieldset')?.querySelector('legend')?.textContent||'')){chosen=true;setTimeout(update,250);}
  });
  document.addEventListener('change',ev=>{
    if(ev.target.closest('.variant-picker')) { 
      if(/size/i.test(ev.target.name||ev.target.closest('fieldset')?.querySelector('legend')?.textContent||''))chosen=true;
      setTimeout(update,350);
    }
  });
  document.addEventListener('variant:update',()=>{setTimeout(update,100);setTimeout(update,400);});
  window.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update,{passive:true});
  media.addEventListener?.('change',update);
  document.addEventListener('shopify:section:load',update);
  const obs=new MutationObserver(()=>{ if(!updating) requestAnimationFrame(update);});
  const scope=details();
  if(scope)obs.observe(scope,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','hidden','class']});
  update();
})();